<div class="snackbar-container">
  @if (isRich) {
    <!-- Rich notification with icon, message and optional detail line -->
    <mat-icon class="snackbar-icon">
      {{ richData.icon || (richData.panelClass === 'success-snackbar' ? 'check_circle' : 'error') }}
    </mat-icon>
    <div class="snackbar-body">
      <span class="snackbar-message">{{ richData.message }}</span>
      @if (richData.details) {
        <div class="snackbar-details-row">
          <span
            class="snackbar-details"
            [matTooltip]="richData.details"
            matTooltipPosition="below"
            >{{ richData.details }}</span
          >
          @if (richData.copyValue) {
            <button
              class="copy-btn"
              mat-icon-button
              [matTooltip]="copied ? 'Copied!' : 'Copy QC code'"
              matTooltipPosition="below"
              (click)="copy()"
              aria-label="Copy QC code"
            >
              <mat-icon>{{ copied ? 'check' : 'content_copy' }}</mat-icon>
            </button>
          }
        </div>
      }
    </div>
  } @else {
    <!-- Legacy plain-string fallback (used by old NotificationService calls) -->
    <span>{{ plainMessage }}</span>
  }
  <div class="button-container">
    <button (click)="snackBarRef.dismiss()" mat-icon-button aria-label="Clear">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
